// import gsap from 'gsap';
// import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger)

const Animation = new function () {
    let elements = []
    
    this.init = () => {

        if (document.querySelector('.animation--loop')) {
            let sec7 = document.querySelectorAll('.ss-section--7');
            sec7.forEach(section => {
                let sectionCnt = section.querySelector('.ss-section__cnt');
                let sectionHeight = sectionCnt.scrollHeight + 200;
    
                section.querySelectorAll('.animation--loop').forEach(container => {
                    const animDataUrl = container.dataset.json;
                    if (animDataUrl) {
                        const anim = lottie.loadAnimation({
                            container: container,
                            loop: true,
                            autoplay: false,
                            renderer: 'svg',
                            path: animDataUrl
                        });
    
                        elements.push({
                            el: container,
                            animation: anim
                        });
    
                        ScrollTrigger.create({
                            trigger: container,
                            start: "top center",
                            end: () => `top -${sectionHeight}px`,
                            // markers: true,
                            scroller: document.querySelector('#ss-page'),
                            onEnter: () => anim.play(),
                            onLeave: () => anim.pause(),
                            onEnterBack: () => anim.play(),
                            onLeaveBack: () => anim.pause(),
                        });
                    }
                });
            });
        }

        if (document.querySelector('.animation--map')) {
            const container = document.querySelector('.animation--map');
            
            const animDataUrl = container.dataset.json;
            if (animDataUrl) {
                const anim = lottie.loadAnimation({
                    container: container,
                    loop: true,
                    autoplay: false,
                    renderer: 'svg',
                    path: animDataUrl
                });

                elements.push({
                    el: container,
                    animation: anim
                });

                ScrollTrigger.create({
                    trigger: container,
                    start: "top center",
                    end: "+=950",
                    // markers: true,
                    scroller: document.querySelector('#ss-page'),
                    onEnter: () => anim.play(),
                    onLeave: () => anim.pause(),
                    onEnterBack: () => anim.play(),
                    onLeaveBack: () => anim.pause(),
                });
            }
        }

        if (document.querySelector('.animation--once')) {
            document.querySelectorAll('.animation--once').forEach(container => {
                const animDataUrl = container.dataset.json;
                if (animDataUrl) {
                    const anim = lottie.loadAnimation({
                        container: container,
                        loop: false,
                        once: true,
                        autoplay: false,
                        renderer: 'svg',
                        path: animDataUrl
                    });

                    elements.push({
                        el: container,
                        animation: anim
                    });

                    ScrollTrigger.create({
                        trigger: container,
                        start: "top center",
                        // markers: true,
                        scroller: document.querySelector('#ss-page'),
                        onEnter: () => anim.play(),
                    });
                }
            });
        };

    };
    
    this.kill = () => {
        elements.forEach(element => {
            element.animation.destroy();
            ScrollTrigger.kill(element.el);
        });
    };

}

export default Animation